import React from 'react'
import moment from 'moment';
import RenderProfilePicture from '../../../../_helpers/profile-picture';
import { Row, Col, Container } from 'react-bootstrap'

export default function MostRecentMessage({ lastMessage }) {
  const renderLastMessage = (type) => {
    switch (type) {
      case 'message':
        return `"${lastMessage.payload.text.slice(0, 110)}${lastMessage.payload.text.length > 109 ? '...' : ''}"`
      case 'attachment':
        let attachmentType = ''
        if (lastMessage.payload.type.includes('image')) {
          attachmentType = 'Image'
        }
        if (lastMessage.payload.type.includes('pdf')) {
          attachmentType = 'PDF'
        }
        return <span style={{ fontSize: '12px', width: '125px' }} className='mb-0 badge badge-info text-capitalize py-2 px-3'>{attachmentType} Sent</span>
      default:
        return <span style={{ fontSize: '12px', width: '125px' }} className='mb-0 badge badge-info text-capitalize py-2 px-3'>{type} Sent</span>
    }
  }

  const now = moment().utc()
  const sentAt = moment.utc(lastMessage.sentAt.date)

  return (
    <Container>
      <Row className='mb-3'>
        <Col xs='auto' className='pr-0'>
          <RenderProfilePicture image={lastMessage.sentBy.profile} circle cached={true} width={18} height={18} className='m-auto' />
        </Col>
        <Col xs='auto' className='text-muted'>
          {`${lastMessage.sentBy.firstName} ${lastMessage.sentBy.lastName}`}
          <small className='ml-2 font-weight-light'>{lastMessage.sentBy.userType}</small>
        </Col>
        <Col className='text-right text-muted mr-4'>
          <div className='message__sent_by_date'>
            {now.diff(sentAt, 'hours') > 4
              ? sentAt.local().format('lll')
              : sentAt.local().fromNow()}
          </div>
        </Col>
      </Row>
      <Row>
        <Col className={`${lastMessage.type === 'message' ? 'pb-2' : ''}`}>
          {renderLastMessage(lastMessage.type)}
        </Col>
      </Row>
    </Container>
  )
}
